<div data-testid="vendor-form-container" class="vendor-form-container">
  <app-add-form
    data-testid="vendor-form"
    #addForm
    [title]="
      (isAddMode()
        ? 'vendor.add.title'
        : isViewMode()
          ? 'vendor.view.title'
          : 'vendor.edit.title'
      ) | translate
    "
    [formFields]="formFields()"
    [headerActions]="headerActions()"
    [loading]="loading()"
    [initialData]="vendorData()"
    [editMode]="isEditMode()"
    [viewMode]="isViewMode()"
    [tableSections]="tableSectionsForForm()"
    [getFieldError]="getBankAccountFieldError"
    [taxValidationLoading]="validatingTax()"
    (formAction)="onFormAction($event)"
    (formValueChanges)="onFormValueChanges($event)"
    (tableAction)="onTableAction($event)"
    (taxValidationClick)="onValidateTaxId()"
  >
    <!-- Actions template for bank accounts table -->
    <ng-template #actionsTemplate let-rowData>
      @if (!isViewMode()) {
        <div class="flex gap-2 justify-center">
          <app-button
            [testId]="'vendor-form-action-delete-bank-account-' + rowData.id"
            class="action-delete"
            [label]="'common.actions.delete' | translate"
            type="action"
            (emitOnClick)="onDeleteBankAccountClick(rowData)"
          ></app-button>
        </div>
      }
    </ng-template>
  </app-add-form>
</div>

<p-toast data-testid="vendor-form-toast"></p-toast>
